import React from "react";
import cx from "classnames";

type Props = {
  label: string;
  value: string;
  name: string;
  radioStyle?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Radio: React.FC<Props> = ({
  label,
  value,
  name,
  className,
  defaultChecked,
  onChange,
  radioStyle,
}): JSX.Element => {
  return (
    <div className="flex flex-row">
      <input
        className={cx("mr-2 my-auto", radioStyle)}
        type="radio"
        value={value}
        checked={defaultChecked}
        onChange={onChange}
        name={name}
      />
      <span className={cx("font-nunito", className)}>{label}</span>
    </div>
  );
};

export default Radio;
